import 'moment-timezone'

import { Texto } from '@gravitate-js/excalibrr'
import { formatters } from '@utils/intl/dateTimeFormatters'
import moment from 'moment'
import React from 'react'
import NumberFormat from 'react-number-format'

const regularNumber = (value) => <NumberFormat value={value} thousandSeparator displayType='text' decimalScale={0} />

const regularColoredNumber = (row) => (
  <NumberFormat
    value={row.value}
    thousandSeparator
    displayType='text'
    decimalScale={0}
    className={classColor(Math.round(row.value))}
  />
)
const dollarNumber = (row) => (
  <NumberFormat value={row.value} thousandSeparator prefix='$' displayType='text' decimalScale={0} />
)

function PriceNumber({ value, precision }) {
  return (
    <NumberFormat
      value={value}
      thousandSeparator
      prefix='$'
      displayType='text'
      decimalScale={precision}
      fixedDecimalScale
    />
  )
}

export function DateTime({ data, timezone }) {
  return <Texto textTransform='uppercase'>{formatters.DATE_TIME(data, timezone)}</Texto>
}

const timeOfDay = (row) => <Texto textTransform='uppercase'>{formatters.TIME(moment(row.value))}</Texto>

const dateOnly = (row) => <Texto>{formatters.DATE(moment(row.value))}</Texto>

const colorNumber = (row) => (
  <NumberFormat
    value={row.value}
    thousandSeparator
    prefix='$'
    displayType='text'
    className={classColor(Math.round(row.value))}
    decimalScale={0}
  />
)

const coloredPrice = (row) => (
  <NumberFormat
    value={row.value}
    thousandSeparator
    prefix='$'
    displayType='text'
    className={classColor(Math.round(row.value * 100))}
    decimalScale={4}
    fixedDecimalScale
  />
)

export function durationFormatter(time, unit = 'minutes') {
  const duration = moment.duration(time, unit)

  // Extract days, hours, and minutes from the duration
  const days = Math.floor(duration.asDays())
  const hours = duration.hours()
  const mins = duration.minutes()

  // Format the duration into a human-readable string
  let result = ''
  if (days > 0) {
    result += `${days}d `
  }
  if (hours > 0) {
    result += `${hours}h `
  }
  if (mins > 0 || result === '') {
    result += `${mins}m`
  }

  return result.trim()
}

const percentage = (value) => (
  <NumberFormat value={value * 100} thousandSeparator suffix='%' displayType='text' decimalScale={0} />
)

const classColor = (value) => {
  if (value < 0) return 'Red'
  if (value > 0) return 'Green'
  return 'Black'
}

export default {
  reg: regularNumber,
  regc: regularColoredNumber,
  dol: dollarNumber,
  col: colorNumber,
  price: PriceNumber,
  cprc: coloredPrice,
  tod: timeOfDay,
  date: dateOnly,
  dt: DateTime,
  pct: percentage,
}
